"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePostsByIds = exports.getDefaultTagLine = exports.getStatus = exports.getBtnText = exports.getSubTitle = exports.getTitle = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getTitle = function getTitle(_ref) {
  var isPublished = _ref.isPublished;
  return "".concat(isPublished ? 'Unpublish' : 'Publish', " post");
};

exports.getTitle = getTitle;

var getSubTitle = function getSubTitle(_ref2) {
  var isPublished = _ref2.isPublished;
  return "Are you sure you want to ".concat(isPublished ? 'unpublish' : 'publish', " this post?");
};

exports.getSubTitle = getSubTitle;

var getBtnText = function getBtnText(_ref3) {
  var isPublished = _ref3.isPublished;
  return isPublished ? 'Unpublish' : 'Publish';
};

exports.getBtnText = getBtnText;

var getStatus = function getStatus(_ref4) {
  var isPublished = _ref4.isPublished;
  return isPublished ? 'DRAFT' : 'PUBLISHED';
};

exports.getStatus = getStatus;

var getDefaultTagLine = function getDefaultTagLine(posts) {
  return posts[0].tagLine || '';
};

exports.getDefaultTagLine = getDefaultTagLine;

var updatePostsByIds = function updatePostsByIds(posts, postsIdsToEdit, postPayload) {
  return posts.map(function (post) {
    return postsIdsToEdit.includes(post.inspirationId) ? _objectSpread({}, post, {}, postPayload) : post;
  });
};

exports.updatePostsByIds = updatePostsByIds;